module.exports = __webpack_public_path__ + "static/media/ku.4823b262.png";